/**
 * Design tokens taken 1:1 from the Figma frame "Evan Szu" (node 1538-13288).
 * The frame is 1920px wide; every px value below is the raw Figma value.
 */

export const bg = "#060B14";
export const cardBg = "#0C1320";
export const accent = "#39CA88";

/** White at a given alpha — the design expresses nearly every colour this way. */
export const w = (alpha: number) => `rgba(255, 255, 255, ${alpha})`;

export const font = {
  sans: "'DM Sans', sans-serif",
  ui: "'Inter', sans-serif",
  mono: "'Menlo', 'SFMono-Regular', monospace",
  serifAlt: "'Lato', sans-serif",
};

/** Breakpoints. The design only exists at 1920 — everything below is adaptation. */
export const bp = {
  lg: "@media (max-width: 1440px)",
  md: "@media (max-width: 1100px)",
  sm: "@media (max-width: 760px)",
};

/**
 * Fluid px value: exactly `max` at 1920px viewport and above, scaling down
 * proportionally to `min` at 1100px. Keeps the desktop layout pixel-accurate
 * while letting it breathe on smaller screens.
 */
export const fluid = (min: number, max: number) =>
  `clamp(${min}px, calc(${min}px + (${max} - ${min}) * ((100vw - 1100px) / 820)), ${max}px)`;

/**
 * The filled-button gradient, with a different starting grey per button:
 * header #7D8188, hero #808388, "Request a copy" #575B63.
 *
 * Figma's gradient handles are normalised to the shape, so on these wide
 * buttons (282×57) they resolve to a near-horizontal 108° sweep running from
 * 17% to 101% of the CSS gradient line — not the 148° a naive reading gives.
 */
export const buttonGradient = (from = "#808388") =>
  `linear-gradient(108deg, ${from} 17%, #060B14 101%)`;

export const buttonBorder = "rgba(60, 74, 63, 0.3)";
